var map = {
	"./home-entertainment.de-CH.json": 1415,
	"./home-entertainment.de-DE.json": 1416,
	"./home-entertainment.en-CA.json": 1417,
	"./home-entertainment.en-GB.json": 1418,
	"./home-entertainment.en-IN.json": 1419,
	"./home-entertainment.en-ME.json": 1420,
	"./home-entertainment.en-US.json": 1421,
	"./home-entertainment.es-EM.json": 1422,
	"./home-entertainment.es-ES.json": 1423,
	"./home-entertainment.fr-BE.json": 1424,
	"./home-entertainment.fr-CA.json": 1425,
	"./home-entertainment.fr-CH.json": 1426,
	"./home-entertainment.nl-BE.json": 1427,
	"./home-entertainment.nl-NL.json": 1428,
	"./home-entertainment.pl-PL.json": 1429,
	"./home-entertainment.pt-BR.json": 1430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1414;